export default {
  user: {},
  channel: {},
  post: {}
};
